// Centered spatial filtering steadies the completed interior of a stroke.
// The newest endpoint is never filtered: it remains under the native cursor.
export function smoothPenSample(before, point, after, smoothing) {
  const weight = Math.max(0, Math.min(100, Number(smoothing) || 0)) / 200
  return {
    x: point.x + ((before.x + after.x) / 2 - point.x) * weight,
    y: point.y + ((before.y + after.y) / 2 - point.y) * weight,
  }
}
